import "./TradingIdeasPayoffChartComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {TradingIdeasViewStore} from "../../../store/TradingIdeasViewStore";
import {ReplaySubject, Scheduler} from "rxjs";
import {TradingIdeaType} from "../../../models/TradeIdeaRecord";

export const PayoffChart = "tfTradingIdeasPayoff";

export function payoffChart(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/element/TradingIdeasPayoffChartComponent.html`,
        bindings: {
            store: "<"
        },
        controllerAs: "ctrl",
        controller: TradingIdeasPayoffChartComponentController
    };
}

export class TradingIdeasPayoffChartComponentController implements IOnInit, IOnDestroy {

    /** @Input */
    public readonly store: TradingIdeasViewStore;

    public readonly ideaType$ = new ReplaySubject<TradingIdeaType>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    public $onInit(): void {
        this.store
            .currentModel
            .takeUntil(this.destroyed$)
            .observeOn(Scheduler.async)
            .map((model) => model.idea)
            .map((idea) => idea.type)
            .subscribe((type) => this.ideaType$.next(type));
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
